export class PaymentSettings {
  none?: boolean;
  card: boolean;
  agencyCard: boolean;
  agencyCash: boolean;
}
